<template>
  <v-menu
    :close-on-content-click="close_on_content_click"
    content-class="pa-0 ma-0"
    max-height="400px"
    offset-y>
    <template #activator="{ on, value: active }">
      <div v-on="on">
        <sButton
          class="mr-4 py-1 px-2 h11-links"
          :color="active ? '#000000a6' : 'var(--black-color)'"
          data-qa="btn-column"
          :disabled="disabled"
          icon="column"
          type="text">
          {{ name || $t('Planning.View') }}
        </sButton>
      </div>
    </template>
    <div
      class="select-coliumns list filters-menu-list menu py-2 px-3"
      data-qa="filters-menu-list">
      <v-checkbox
        v-for="item in variants"
        :key="item.text"
        v-model="model"
        color="var(--black-color)"
        data-qa="filters-menu-list-item"
        hide-details
        :ripple="false"
        :value="item"
        :value-comparator="valueComparator">
        <template #label>
          <span class="black--text h7-text">{{ bigFirstLetter(item.text) }}</span>
        </template>
      </v-checkbox>
    </div>
  </v-menu>
</template>
<script>
import { modalMixin } from 'mixins'

export default {
  name: 'selectColumns',
  mixins: [modalMixin],
  props: {
    /**
     * чи закривати меню при кліку на контент
     */
    close_on_content_click: Boolean,
    /**
     * варінти вибору
     */
    variants: {
      type: Array,
      required: true
    },
    /**
     * варінти вибору
     */
    name: {
      type: String,
    },
    /**
     * обране значення
     */
    value: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean
    },
    /**
     * сортування за, якщо передати пустим, сортувати не буде
     */
    sort_by: {
      type: String,
      default: 'id'
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', this.sort_by ? this.$_.sortBy(value, this.sort_by) : value)
      }
    }
  },
  methods: {
    valueComparator(selected, val) {
      return selected.value == val.value
    }
  }
}
</script>
<style lang="scss">
.select-coliumns.list {
  .v-input--checkbox {
    margin-top: 0 !important;
    &:first-child {
      padding-top: 0 !important;
    }
    &:not(:first-child) {
      padding-top: 10px !important;
    }
  }
}
</style>
